import { pages } from '@/services/Api'

export default {
  fetchPages() {
    return pages.post('/graphql', {
      query: `
        query Pages {
          pages(removed: false) {
            id
            name
            title
            category
            published
            updatedAt
          }
        }
      `,
    })
  },

  fetchThemes(owner = false) {
    return pages.post('/graphql', {
      query: `
        query Pages {
          themes(owner: ${owner}) {
            id
            name
            category
            description
            thumbnail
            preview
            createdAt
            updatedAt
            locale
            public
          }
        }
      `,
    })
  },

  fetchTheme(id) {
    return pages.post('/graphql', {
      query: `
        query Pages {
          theme(id: "${id}") {
            id
            data
            name
            description
            category
            locale
            preview
            previews
            public
          }
        }
      `,
    })
  },

  savePage(input) {
    return pages.post('/graphql', {
      query: `
        mutation SavePage($input: SavePageInput!) {
          savePage(input: $input) {
            id
          }
        }
      `,
      variables: {
        input,
      },
    })
  },

  duplicatePage(input) {
    return pages.post('/graphql', {
      query: `
        mutation Dupe($input: DuplicatePageInput!) {
          duplicatePage(input: $input) {
            id
          }
        }
      `,
      variables: {
        input,
      },
    })
  },

  removeTheme(themeId) {
    return pages.post('/graphql', {
      query: `
        mutation RemoveTheme($theme: ID!) {
          removeTheme(theme: $theme)
        }
      `,
      variables: {
        theme: themeId,
      },
    })
  },

  saveTheme({ id, name, description, category, locale, isPublic }) {
    return pages.post('/graphql', {
      query: `
        mutation SaveTheme($input: SaveThemeInput!) {
          saveTheme(input: $input) {
            id
          }
        }
      `,
      variables: {
        input: { id, name, description, category, locale, public: isPublic },
      },
    })
  },

  copyThemeToProduction(themeId) {
    return pages.post('/graphql', {
      query: `
        mutation {
          copyThemeToProduction(theme: "${themeId}")
        }
      `,
    })
  },
}
